///<reference path="../Core/Frame.js"/>
/// <reference path="./publicFunctions.js" />
/// <reference path="../ipsAutoComplete/ipsAutoComplete.js" />
/// <reference path="../html5controls/controls/inforApplicationNav/js/inforApplicationNav.js" />
// flag to indicate if this document has jquery scripts or if its using it from the hframe.htm
var _jqueryScriptAdded = false;
// applies the public members to this current view
window.parent.applyPublicFunctions(window,window.parent.moniker);
var locale = instance._Locale;
window.localInfo = instance.Globalize;
if (locale && locale != "" && localInfo) {
  if (localInfo.culture().isRTL) {
    $("html").attr("dir", "rtl");
  } else {
    $("html").removeAttr("dir");
  }
  $("html").attr("lang", locale);
  Globalize.culture(locale);
}
hideMenu = menuHidden();
var _contentEditorFlag = false;
var _contentEditorRule = "ContentEditorMenuClick";
var hideMenu;
var _suppressTabSelection = false;

function showSearch() {
  instance.isSearchEnabled = true;
}

function setModuleSize() {}
document.onreadystatechange = function() {
  if (document.readyState === "complete") {
    document.onreadystatechange = null;
    if (hideMenu) {
      $(document.getElementById("MenuCell")).remove();
      $(document.getElementById("__moduleTools__")).remove();
      $(document.body).addClass("hideMenu");
    } else {
      initializeMenu();
      window.min = document.getElementById("__minimize__");
      window.max = document.getElementById("__maximize__");
      window.signOut = document.getElementById("signOut");
      var processMinMax = function(e, isMax) {
        if (instance.IsStandAlone()) {
          instance.easeOfUse.hideHeader = isMax;
          instance.showApplicationHeader(undefined, true);
        }
        instance.easeOfUse.hideMenu = isMax;
        instance.window.frames["menuAndView"].showMenuVisibility();
        instance.saveHeaderMenuChanges();
      };
      window.max.onclick = function(e) {
        processMinMax(e, true);
      };
      window.min.onclick = function(e) {
        processMinMax(e, false);
      };
      window.signOut.onclick = instance.signOut;
    }
    showMenuVisibility();
    if (instance.isModalDiv) {
      $(document.body).addClass("modalDiv");
    }
    $(document.body).addClass(instance.runtimeMode);

    //search input code start
    const searchBar = document.getElementById('searchBar');
    const searchInput = document.getElementById('searchInput');
    const searchResults = document.getElementById('searchResults');
    const lastChangedByInput = document.getElementById("lastChangedByInput");
    const assignedToInput = document.getElementById("assignedToInput");
    const searchResultsPanel = document.getElementById('searchResultsPanel');
    const clearSearch = document.getElementById('clearSearch');

    if (instance.isSearchEnabled) {
      //$(searchBar).show();
      $('#formCode').hide();
    } else {
      //$(searchBar).hide();
      $('#formCode').show();
    }

    if (clearSearch) {

      clearSearch.addEventListener('click', function () {
        document.getElementById('searchInput').value = ''; // Clear search input
        performSearch();
        searchInput.focus();
      });

     
    lastChangedByInput.addEventListener('click', function (event) {
      performUserSearch('lastChangedByInput', 'lastChangedByDropdownContent');
      showDropdown('lastChangedByInput', 'lastChangedByDropdownContent');
    });

    assignedToInput.addEventListener('click', function (event) {
      performUserSearch('assignedToInput', 'assignedToDropdownContent');
      showDropdown('assignedToInput', 'assignedToDropdownContent');
    });

    searchResultsPanel.addEventListener('click', function() {
      hideDropdown('lastChangedByInput', 'lastChangedByDropdownContent');
      hideDropdown('assignedToInput', 'assignedToDropdownContent');
    });

    // Event listener for escape key
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            searchInput.classList.remove('expanded');
            searchResults.classList.remove('active');
        }
    });

      document.addEventListener('mousedown', function (event) {
        var isClickWithinDiv = searchInput.contains(event.target) || searchResults.contains(event.target) || document.getElementById('clearSearch').contains(event.target);

        if (isClickWithinDiv) {
            searchInput.classList.add('expanded');
            searchResults.classList.add('active');
        } else {
            searchInput.classList.remove('expanded');
            searchResults.classList.remove('active');
        }
    });

    // Event listener for enter key
    searchInput.addEventListener('keypress', function (event) {
      if (event.key === 'Enter') {
        performSearch();
      }
    });

    // Event listener for focusing on search input
    searchInput.addEventListener('focus', () => {
        hideActionMenu();
        hideDropdown('lastChangedByInput', 'lastChangedByDropdownContent');
        hideDropdown('assignedToInput', 'assignedToDropdownContent');
        searchInput.classList.add('expanded');
        if (searchInput.value.trim().length == 0)
          performSearch();

        attachCloseSearchEvents();
    });
     
    document.getElementById('detailedViewCloseButton').addEventListener('click', () => {
        document.getElementById('searchCriteriaList').classList.add('active');
        document.getElementById('detailedViewList').classList.remove('active');
    });
     
    const search = debounce(performSearch, 500);

    searchInput.addEventListener('keyup', function(event) {
      if (event.key !== 'Escape') {
        search();
      }
    });

    lastChangedByInput.addEventListener('keyup', debounce(() => { 
      performUserSearch('lastChangedByInput', 'lastChangedByDropdownContent'); 
    }, 300));

    assignedToInput.addEventListener('keyup', debounce(() => { 
      performUserSearch('assignedToInput', 'assignedToDropdownContent');
    }, 300));
    //search input code end
    }
  }
};
window.onunload = function() {
  document.onkeydown = null;
  if (window.min) {
    window.max.onclick = null;
    window.max = null;
    window.min.onclick = null;
    window.min = null;
    window.signOut.onclick = null;
    window.signOut = null;
  }
  if (window.$) {
    var $input = $("#__formcodeinput__");
    $input.off();
    $input.remove();
  }
  if (window.Globalize) {
    var g = window.Globalize();
    g.cultures = null;
    window.Globalize.prototype = null;
    window.Globalize = null;
  }
  window.localInfo = null;
  instance.removePublicFunctions(window);
  window.instance = null;
  document.getElementById("hansenView").applyPublicFunctions = null;
};
function showOrHideSignOut(show) {
  var signOut = document.getElementById("signOut");
  if (signOut) {
    if (show) {
      signOut.style.display = "inline-block";
    } else {
      signOut.style.display = "none";
    }
  }
}
function showMenuVisibility() {
  if (instance.easeOfUse && instance.easeOfUse.hideMenu) {
    $(document.body).addClass("menuVisibilityHidden");
  } else {
    $(document.body).removeClass("menuVisibilityHidden");
  }
}
function removeMenu() {
  $("#inforApplicationNav1").remove();
}
function openFormCode(code) {
  if (code.length > 0) {
    var menuItem = $("li[formcode='" + code.toUpperCase() + "']").get();
    if (menuItem.length > 0) {
      //one item has one form code
      processClick(menuItem[0]);
    }
  }
}
function initializeMenu() {
  instance.menuInitialized = true;
  _jqueryScriptAdded = true;
  //allow cross site scripting on IE for the sample ajax call
  jQuery.support.cors = true;
  //Initialize the nav plugin - really in simple cases you just need this line with no options.
  var useInforDesign = instance.easeOfUse.useInforDesign;

  if (useInforDesign === false) {
    $("#inforApplicationNav1").inforApplicationNav({
      showSessionMenu: false,
      sortable: false,
      backgroundIFrame: true
    });
  }

  initializeModuleTabs();
  var $input = $("#__formcodeinput__");
  $input.on("keypress", function(e) {
    if (e.keyCode == 13) {
      e.preventDefault();
      e.stopPropagation();
      var code = $input.val().replace(/[^a-zA-Z 0-9]+/g, ""); //remove non-alphanumeric characters
      if (code.length > 0) {
        code = code.toUpperCase();
        var MenuCode = $("li[formcode='" + code + "']");
        if (MenuCode.length > 0) {
          //one item has one form code
          processClick(MenuCode[0]);
        } else {
          var MenuCode = $("a").filter(function(index) {
            return (
              $(this)
                .text()
                .toUpperCase()
                .indexOf(code) !== -1
            );
          });
          if (MenuCode.length > 0) {
            //one item has one form code
            processClick(MenuCode[0].parentNode);
          } else {
            $("body").inforSlideInMessage({
              messageType: "Info",
              messageTitle: "info",
              errorMessage: code.toUpperCase() + " - Invalid Form Code",
              showClose: true,
              autoDismiss: true
            });
          }
        }
      }
      $input.val("");
    }
  });
  var menuItems = $("li[formcode]");
  var autoCompleteItems = new Array();
  var found = new Object();
  for (var i = 0; i < menuItems.length; i++) {
    var code = menuItems[i].getAttribute("formcode");
    if (!found[code]) {
      found[code] = true;
      autoCompleteItems.push({
        label: $(menuItems[i]).text() + " (" + code + ")",
        value: code
      });
    }
  }
  $input.autocomplete({
    autoFocus: false,
    id: "__formcodeautocomplete",
    source: autoCompleteItems,
    select: function(event, ui) {
      var formCodeVal = ui.item.value.toUpperCase();
      if (formCodeVal.length > 0) {
        var menuItem = $("li[formcode='" + formCodeVal + "']").get();
        if (menuItem.length > 0) {
          $input.val("");
          //one item has one form code
          processClick(menuItem[0]);
          //blur the field to prevent and additional keypress
          $input.blur();
          return false;
        }
      } else {
        //if an item does not have form code, but is available from the auto complete
        $("body").inforSlideInMessage({
          messageType: "Info",
          messageTitle: "info",
          errorMessage: " Invalid form code entered.",
          showClose: true,
          autoDismiss: true
        });
      }
      $input.val("");
    }
  });
  //if (
  //  instance.runtimeMode == "Development" &&
  //  instance.easeOfUse.showDeveloperTools
  //) {
  //  var lang = instance._Locale;
  //  var previousLang = localStorage["lang"];
  //  if (previousLang) {
  //    lang = previousLang;
  //  }
  //  $("#__moduleTools__").prepend(
  //    $(
  //      "<label style='position:relative;top:0px;height:10px;margin-right:5px;font-size: 9px' for='language' title='ar-EG, ar-SA, cs-CZ, da-DK, ro-RO, jp-JP'>UI Lang:</label><input style='position:relative;top:0px;height:10px;margin-right:25px;font-size: 9px' class='ui-autocomplete-input' id='language' size='5' type='text' value='" +
  //        lang +
  //        "' />"
  //    ).change(function() {
  //      var newLang = $("#language").val();
  //      localStorage["lang"] = newLang;
  //      log("Changing to " + newLang + " culture");
  //      instance.window.location.reload();
  //    })
  //  );
  //}
}
function menuHidden() {
  return document.location.search.toLowerCase().indexOf("showmenu=true") < 0;
}
//HPS-66961
function showJumpToForm() {
  var $input = $("#__formcodeinput__");
  $input.val("");
  $input.focus();
}
function handleMenuItemClick(sessionId, sessionText, targetViewId) {
  //hideTabPreview();
}
function processClick(item) {
  var value = "";
  if (item) {
    value =
      item.getAttribute("moniker") + ";" + item.getAttribute("valueTitle");
  }
  if ($(item).attr("navigateUrl")) {
    if ($(item).attr("navigateWindow")) {
      var w, h;
      if (item.windowWidth != null && item.windowHeight != null) {
        w = item.windowWidth;
        h = item.windowHeight;
      } else {
        w = 800;
        h = 600;
      }
      var newWindow = window.open(
        $(item).attr("navigateUrl"),
        "_blank",
        "height=" +
          h +
          ",width= " +
          w +
          ",scrollbars=yes,resizable=yes,menubar=yes,location=yes,directories=no,status=yes,toolbar=yes" +
          instance.frames["cblock"].calculateCenteredWindowPosition(w, h)
      );
    } else {
      instance.ownerDocument.location.replace($(item).attr("navigateUrl"));
    }
  } else if (item.getAttribute("ruleId")) {
    var formTitle =
      $(item).text() + " (" + item.getAttribute("formcode") + ") ";
    if (_contentEditorFlag) {
      MenuClick(_contentEditorRule, value, formTitle, "");
    } else {
      var home = GetHomeView();
      var apid = getApId(home);
      // Publish a shortcut message to enable the "favorite" icon for this applet
      if (instance.contextMessaging) {
        var params = item.getAttribute("appletparams");
        var msg = {
          name: formTitle,
          description: formTitle,
          absoluteURL: "false",
          shortcutContext: value + ";" + formTitle + ";" + params
        };
        //console.log('Publishing: setShortcutContext, ' + JSON.stringify(msg, null, 2));
        instance.contextMessaging.PublishContextMessage(
          "setShortcutContext",
          msg
        );
      }
      var targetView = null;
      var vid = MenuClick(
        item.getAttribute("ruleId"),
        value,
        formTitle,
        apid,
        targetView,
        item.getAttribute("appletParams")
      );
    }
  }
}
function getApId(home) {
  var apid = "";
  if (home && home.ownerDocument) {
    if (
      home &&
      home.ownerDocument.forms[0] &&
      home.ownerDocument.forms[0].getAttribute("apid") != undefined
    )
      apid = home.ownerDocument.forms[0].getAttribute("apid");
  } else {
    if (
      home &&
      home.document.forms[0] &&
      home.document.forms[0].getAttribute("apid") != undefined
    )
      apid = home.document.forms[0].getAttribute("apid");
  }
  return apid;
}
function removeClickBarrier() {
  hideWaitMsg(null);
  $(document.getElementById("clickbarrier")).remove();
  if (GetView(null))
    if (document == GetViewDocument(null)) {
      var navi = GetNaviBar(null);
      // ADS 13-Jan-2005 - Added additional boiler-plate
      if (navi) {
        var clkBar = navi.ownerDocument.getElementById("clickbarrier");
        if (clkBar) $(clkBar).remove();
      }
    }
}

function filterDateTime() {
  performSearch();
}

let setRecordtypeOptionsNeeded = true;

function filterRecordType() {
  setRecordtypeOptionsNeeded = false;

  var elem = document.getElementById('recordTypeSelect');
  if (elem) {
    var val = elem.value;
    if (val == 'any') {
      setRecordtypeOptionsNeeded = true;
    }
  }

  performSearch();
}

function getLastUpdatedFilterParam() {
  const lastUpdatedValue = lastUpdatedSelect.value.trim();
  let gteValue = null;
  let rangeParam = null;

  switch(lastUpdatedValue.toLowerCase()) {
    case 'lastday':
      gteValue = getDate(1);
      break;
    case 'lastweek':
      gteValue = getDate(7);
      break;
    case 'lastmonth':
      gteValue = getDate(31);
      break;
    case 'lastyear':
      gteValue = getDate(365);
      break;
    default:
      break;
  }

  if (gteValue) {
    rangeParam = {
      range: {
        modifiedDate: {
          gte: gteValue,
          lte: getDate()
        }
      }
    };
  }

  return rangeParam;
}

function getDate(dayOffset = 0) {
  var d = new Date();
  d.setDate(d.getDate() - dayOffset);

  const month = d.getUTCMonth() + 1; // months from 1-12
  const day = d.getUTCDate();
  const year = d.getUTCFullYear();

  const newDate = year + "-" + month + "-" + day;
  //return newDate;

  // Using template literals:
  //const newDate = `${year}/${month}/${day}`;

  // Using padded values, so that 2023/1/7 becomes 2023/01/07
  const pMonth        = month.toString().padStart(2,"0");
  const pDay          = day.toString().padStart(2,"0");
  const newPaddedDate = `${year}-${pMonth}-${pDay}`;

  return newPaddedDate;
}

function getLastChangedByParam() {
  var elem = document.getElementById('lastChangedByInput');
  if (elem && elem.getAttribute('identifier')) {
    var val = elem.getAttribute('identifier').trim();
    return {
          term: {
            modifiedBy: val
          }
        };
  }

  return null;
}

function getRecordTypeParam() {
  var elem = document.getElementById('recordTypeSelect');
  if (elem) {
    var val = elem.value;
    if (val != 'any') {
      return {
        term: {
          "displayType.keyword": val
        }
      };
    }
  }

  return null;
}

function getAssignedToParam() {
  var elem = document.getElementById('assignedToInput');
  if (elem && elem.getAttribute('primarycontact')) {
    var val = elem.getAttribute('primarycontact').trim();
    return {
            "nested": {
              "path": "asignedTo",
              "query": {
                "term": {
                  "asignedTo.fullName.keyword": val
                }
              }
            }
          };
  }

  return null;
}

function buildQuery() {
   
  const inputValue = searchInput.value.trim();
  let rangeParam = getLastUpdatedFilterParam();
  let lastChangedByParam = getLastChangedByParam();
  let assignedToParam = getAssignedToParam();
  let recordTypeParam = getRecordTypeParam();

  let musts = [{
    simple_query_string: {
      query: `$*${inputValue}*^`,
      fields: ["*", "-addedBy", "-modifiedBy"]
    }
  }];

  if (rangeParam)
    musts.push(rangeParam);

  if (lastChangedByParam)
    musts.push(lastChangedByParam);

  if (assignedToParam)
    musts.push(assignedToParam);

  if (recordTypeParam)
    musts .push(recordTypeParam);

  let query = {
    query: {
      bool: {
        must: musts
      }
    },
    aggs: {
      field_type_counts: {
        terms: {
          field: "displayType.keyword",
          size: 500
        }
      }
    },    
  highlight : {
    fields: {
      "*": { }  
    }
  }
  };

  return query;
}


// OneSearch start
function performUserSearch(id, contentId) {
  let elem = document.getElementById(id);
  let val = "";

  let musts = [
        {
          "term": {
            "displayType.keyword": "User"
          }
        }
      ];

  //`*${val}*`
  if (elem) {
    val = elem.value.trim().toLowerCase();
    if (val){
      musts.push({
          "nested": {
            "path": "primaryContact",
            "query": {
              "wildcard": {
                "primaryContact.fullName": ''.concat('*', val, '*')
              }
            }
          }
        });
    }
  }

  let query = {
  "query": {
    "bool": {
      "must": musts
    }
  }
};

  let input = document.getElementById(id);

  console.log('performUserSearch: '.concat(JSON.stringify(query)));

  const endpoint = 'http://localhost:9200/map_search/_search';
  fetch(endpoint, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(query),
  })
      .then(response => response.json())
      .then(data => {
          displayUserSearchResults(data.hits.hits, id, contentId);
          // displaySearchCriteria(data);
      })
      .catch(error => console.error('Error:', error));
}

function performSearch() {
  searchInput.classList.add('expanded');
  searchResults.classList.add('active');
  const inputValue = searchInput.value.trim();

  // close any detail view and get back to criteria.
  document.getElementById('searchCriteriaList').classList.add('active');
  document.getElementById('detailedViewList').classList.remove('active');

  // Perform search only if there are at least 2 characters
  if (inputValue.length >= 2) {
    //const endpoint = 'http://localhost:9200/map_search/_search';
    //let query = buildQuery();
    //console.log('performSearch: '.concat(JSON.stringify(query)));

    var rootPath = _ClientPath.replace(/(Client\/)/i, "");
    // the .* at the end of this is a HACK to get around our compactor as it thinks //i is a COMMENT
    var regex = /^((http|https):\/\/.*?)\/.*/i;
    var domain = regex.exec(document.URL)[1];
    const endpoint = common.combine(domain, rootPath, "api/core/search/query");

    fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "SearchTerms": searchInput.value.trim(),
        "MaxResults": 10
      }),
    })
      .then(response => response.json())
      .then(data => {
        displaySearchResults(data.data.hits.hits);
        if (data.data.hits.hits.length > 0) {
          if (setRecordtypeOptionsNeeded) {
            populateRecordTypeDropdown(data.data);
          }
          setRecordtypeOptionsNeeded = true;
          updateSearchGroupCount(data);
        } else {
          clearRecordTypeDropdown();
        }
        displaySearchCriteria(data);
      })
      .catch(error => console.error('Error:', error));
  } else {
    displayHomeSpace();
  }
}
function performSearch_original() {
    searchInput.classList.add('expanded');
    searchResults.classList.add('active');
    const inputValue = searchInput.value.trim();

    // close any detail view and get back to criteria.
    document.getElementById('searchCriteriaList').classList.add('active');
    document.getElementById('detailedViewList').classList.remove('active');

    // Perform search only if there are at least 2 characters
    if (inputValue.length >= 2) {
        const endpoint = 'http://localhost:9200/map_search/_search';

        let query = buildQuery();

        console.log('performSearch: '.concat(JSON.stringify(query)));
      
        fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(query),
        })
            .then(response => response.json())
            .then(data => {
                displaySearchResults(data.hits.hits);
                if (data.hits.hits.length > 0) {
                  if (setRecordtypeOptionsNeeded) {
                    populateRecordTypeDropdown(data);
                  }
                  setRecordtypeOptionsNeeded = true;
                  updateSearchGroupCount(data);
                } else {
                  clearRecordTypeDropdown();
                }
                displaySearchCriteria(data);
            })
            .catch(error => console.error('Error:', error));
    } else {
        displayHomeSpace();
    }
}

function updateSearchGroupCount(results) {
  results.aggregations.field_type_counts.items.forEach(bucket => {
    var groupElem = document.getElementById(createGroupDivId(bucket.key));
    if (groupElem) {
      groupElem.textContent = ` (${bucket.docCount})`;
    }
  });
}

function createGroupDivId(key) {
  return `${key.replace(/\s+/g, '-')}-group-div`;
}

function displaySearchResults(results) {
    let lastSearchResults = results;
    toggleView('searchResultsPanel');
    const searchResults = document.getElementById('searchResultsList');
  searchResults.innerHTML = '';//'<h2>Search Results</h2>';
  
  let items = results.slice(0, 10);
  let sortedItems = sortItemsByDisplayType(items);
  // Sort the keys of sortedItems while maintaining the original order
  const sortedKeys = Object.keys(sortedItems).sort((a, b) => {
      return items.findIndex(item => item.displayValue == a) - items.findIndex(item => item.displayValue == b);
  });

  sortedKeys.forEach(key => {
    // Create a group div for each key
    const groupDiv = document.createElement('div');
    groupDiv.classList.add('result-item-group');
    groupDiv.textContent = `${key}s`;
    let countLabel = document.createElement('label');
    countLabel.id = createGroupDivId(key);
    countLabel.classList.add('result-item-group-count');
    countLabel.textContent = `(${sortedItems[key].length})`;
    groupDiv.appendChild(countLabel);

    // Iterate through items in the current group
    sortedItems[key].forEach(item => {     
      let card = createSearchCard(item);
      groupDiv.appendChild(card);
    });

    searchResults.appendChild(groupDiv);
  });
}

let currentIdentifier = '';
let currentPrimaryContact = '';

function addCurrentUserToFront(results) {
  let userText = window.parent.document.getElementById('inforBannerText').textContent;
  let identifier = userText.split(' (')[0];
  let primaryContact = userText.split(' (')[1].split(')')[0];

  results.unshift({
    "_source":{
      "primaryContact": {
        "fullName": primaryContact
      },
      "identifier": identifier
    }
  });

  return identifier;
}

function addDefaultRecordType(dropdown) {
  let optionElement = document.createElement('option');
  optionElement.value = 'any';
  optionElement.textContent = 'Any';
  dropdown.appendChild(optionElement);
}

function clearRecordTypeDropdown() {
  var dropdown = document.getElementById('recordTypeSelect');
  while (dropdown.options.length > 0) {
    dropdown.remove(0);
  }

  addDefaultRecordType(dropdown);
}

function populateRecordTypeDropdown(results) {
  var dropdown = document.getElementById('recordTypeSelect');

  const selectedIndex = dropdown.selectedIndex;
  const selectedValue = dropdown.options[selectedIndex].value;

  dropdown.innerHTML = '';

  addDefaultRecordType(dropdown);

  results.aggregations.field_type_counts.items.forEach(bucket => {
    let optionElement = document.createElement('option');
    // optionElement.setAttribute('key', bucket.key);
    optionElement.value = bucket.key;
    optionElement.textContent = makePlural(bucket.key).concat(` (${bucket.docCount})`);
    dropdown.appendChild(optionElement);
  });

  for (let i = 0; i < dropdown.options.length; i++) {
    if (dropdown.options[i].value === selectedValue) {
      dropdown.options[i].selected = true;
      break;
    }
  }
}

function makePlural(word) {
    // Rules for regular plurals
    if (word.endsWith('s') || word.endsWith('ch') || word.endsWith('sh') || word.endsWith('x') || word.endsWith('z')) {
        return word + 'es';
    } else if (word.endsWith('y') && !['a', 'e', 'i', 'o', 'u'].includes(word.charAt(word.length - 2))) {
        // If the word ends with "y" preceded by a consonant
        // Change "y" to "ies"
        return word.slice(0, -1) + 'ies';
    } else if (word.endsWith('f')) {
        // If the word ends with "f", change "f" to "ves"
        return word.slice(0, -1) + 'ves';
    } else if (word.endsWith('fe')) {
        // If the word ends with "fe", change "fe" to "ves"
        return word.slice(0, -2) + 'ves';
    } else {
        // Add "s" by default
        return word + 's';
    }

    return word;
}

function createSearchCardRows(item, result) {
  var row1 = document.createElement("div");
  item.appendChild(row1);
  row1.className = 'result-item-row1';

  var row2 = document.createElement("div");
  item.appendChild(row2);
  row2.className = 'result-item-row2';

  var type = result.displayType;

  if (type == 'Account') {
    populateRow(row1, ['#' + result.identifier, result.subType ? result.subType : 'Test', getName(result.primaryContact)]);
    populateRow(row2, [result.address, result.status]);
  }
  else if (type == 'Work Order') {
    populateRow(row1, ['#' + result.identifier, result.asset, result.subType]);
    populateRow(row2, [result.address ? result.address : (result.parcel ? result.parcel : result.asset), result.status]);
  }
  else if (type == 'Service Request') {
    populateRow(row1, ['#' + result.identifier, result.subType, result.assetType]);
    populateRow(row2, [result.address ? result.address : (result.parcel ? result.parcel : result.asset), result.priority]);
  }
  else if (type == 'Building Permit') {
    populateRow(row1, ['#' + result.identifier, result.subType, result.assetType]);
    populateRow(row2, [result.address ? result.address : (result.parcel ? result.parcel : result.asset), result.status]);
  }
  else if (type == 'Building Inspection') {
    populateRow(row1, ['#' + result.identifier, result.applicationNumber, result.subType]);
    populateRow(row2, [result.address ? result.address : (result.parcel ? result.parcel : result.asset), result.status]);
  }
  else if (type == 'Building Review') {
    populateRow(row1, ['#' + result.identifier, result.applicationNumber, result.subType]);
    populateRow(row2, [result.address ? result.address : (result.parcel ? result.parcel : result.asset), result.status]);
  }
  else if (type == 'Asset') {
    populateRow(row1, ['#' + result.identifier, result.assetType, result.description]);
    populateRow(row2, [result.address ? result.address : (result.parcel ? result.parcel : result.asset), result.status]);
  }
  else if (type == 'Asset Inspection') {
    populateRow(row1, ['#' + result.identifier, result.subType, result.description]);
    populateRow(row2, [result.address ? result.address : (result.parcel ? result.parcel : result.asset), result.priority]);
  }
  else if (type == 'Employee') {
    populateRow(row1, [result.primaryContact.fullName, result.identifier]);
    populateRow(row2, [result.address]);
  }
  else if (type == 'User') {
    populateRow(row1, [result.primaryContact.fullName, result.identifier]);
    populateRow(row2, [result.displayName, result.windowsName]);
  }
  else if (type == 'Address') {
    populateRow(row1, [result.identifier]);
    item.removeChild(row2);
  }
  else if (type == 'Parcel') {
    populateRow(row1, [result.identifier, result.parcelName, result.subType]);
    populateRow(row2, [result.address]);
  }
  else {
    populateRow(row1, [result.identifier]);
    populateRow(row2, [result.address ? result.address : getName(result.primaryContact) ? getName(result.primaryContact) : getName(result.assignedTo)]);
  }
}

function getName(contact) {
  var name = '';

  if (contact) {
    if (contact.fullName)
      name = contact.fullName;
  }

  return name;
}

// columnValues assuming 1 to 3 columns. 
function populateRow(row, columnValues) {
  var newValues = [];

  for (var i = 0; i <= columnValues.length; i++) {
    var value = columnValues[i];

    if (value) {
      newValues.push(columnValues[i]);
    }
  }

 

  columnValues = newValues;
  var isRowOne = row.classList.contains('result-item-row1');
  
  if (columnValues.length == 1) {
    row.innerHTML = columnValues[0].replace(/\s/g, '&nbsp;');
    row.title = columnValues[0];
    if (isRowOne) {
      row.style = 'text-decoration: underline;';
    }
  }
  else if (columnValues.length == 2) {
    var col1 = document.createElement("div");
    row.appendChild(col1);
    col1.className = "result-item-row-column";
    col1.style = `text-align: left;${isRowOne ? "flex:1;text-decoration: underline;" : "flex:1;"}`;
    col1.innerHTML = columnValues[0].replace(/\s/g, '&nbsp;');
    col1.title = columnValues[0];

    if (isRowOne)
      col1.id = 'identifierCell'

    var col2 = document.createElement("div");
    col2.className = "result-item-row-column";
    col2.style = `text-align: right;${isRowOne ? "flex:1;" : "flex:1;"}`;
    row.appendChild(col2);

    col2.innerHTML = columnValues[1].replace(/\s/g, '&nbsp;');
    col2.title = columnValues[1];
  }
  else if (columnValues.length >= 3) {
    var col1 = document.createElement("div");
    row.appendChild(col1);
    col1.className = "result-item-row-column";
    col1.style = `text-align: left;${isRowOne ? "flex:1;text-decoration: underline;" : "flex:1;"}`;
    col1.innerHTML = columnValues[0].replace(/\s/g, '&nbsp;');
    col1.title = columnValues[0];
    if (isRowOne)
      col1.id = 'identifierCell'

    var col2 = document.createElement("div");
    row.appendChild(col2);
    col2.className = "result-item-row-column";
    col2.style = `text-align: left;${isRowOne ? "flex:1;" : "flex:1;"}`;
    col2.innerHTML = columnValues[1].replace(/\s/g, '&nbsp;');
    col2.title = columnValues[1];

    var col3 = document.createElement("div");
    col3.style = `text-align: right;${isRowOne ? "flex:1;" : "flex:1;"}`;
    col3.className = "result-item-row-column";
    row.appendChild(col3);

    col3.innerHTML = columnValues[2].replace(/\s/g, '&nbsp;');
    col3.title = columnValues[2];
  }

  if (columnValues.length > 0) {
    var clearDiv = document.createElement("div");
    clearDiv.className = 'result-item-row-clear';
    row.appendChild(clearDiv);
  }
}

function mergeDeep(target, source) {
  if (typeof target !== 'object' || target === null) {
    target = {};
  }
  for (let key in source) {
    if (source[key] instanceof Object && key in target) {
      target[key] = mergeDeep(target[key], source[key]);
    } else {
      target[key] = source[key];
    }
  }
  return target;
}

function createSearchCard(result) {
  var clonedObject = JSON.parse(JSON.stringify(result.highlight));

  for (let prop in clonedObject) {
    if (Array.isArray(clonedObject[prop])) {
      clonedObject[prop] = clonedObject[prop].join(" ");
    }
  }

  var mergedItem = mergeDeep(result, clonedObject);
 
  result = result;

  var divElement = document.createElement("div");
  divElement.className = "result-item";

  if (result.displayType == "Menu")
    divElement.innerHTML = mergedItem.menuText.replace(/\s/g, '&nbsp;') + " (" + mergedItem.menuFormCode + ") ";
  else {
    createSearchCardRows(divElement, mergedItem);
  }

  var identifierCell = divElement.querySelector("#identifierCell");
  // Check if the child element is found
  if (identifierCell) {
    identifierCell.addEventListener("click", function (e) {
      onZoomToSearchItem(result.moniker, result.primaryKey);
      e.stopPropagation();
    }); 
  }

  divElement.addEventListener("click", function (e) {
    hideActionMenu();
    if (result.displayType == "Adhoc Report") {
      var parts = result.id.split("_");
      var reportPk = parts[parts.length - 1];
      onZoomToSearchItem("Hansen.Core.Reporting.AdhocReportingApplet", reportPk);
    }
    else if (result.displayType == "Menu") {
      var title = result.menuText + " (" + result.menuFormCode + ") ";
      title = title.replace('<em>', '').replace('</em>', '');
      var home = GetHomeView();
      var apid = getApId(home);
      var value = result.menuAppletMoniker + ";" + result.menuText;
      value = value.replace('<em>', '').replace('</em>', '');
      var vid = menuLoadView(apid, value, title, null, result.menuAppletInitParam);
      e.stopPropagation();
      searchInput.classList.remove('expanded');
      searchResults.classList.remove('active');      
    } else {
      if (divElement.classList.contains("clicked")) { // already clicked
        onZoomToSearchItem(result.moniker, result.primaryKey);
        e.stopPropagation();
      }
      else {
        var divs = document.querySelectorAll('.result-item');
        divs.forEach(function (div) {
          div.classList.remove('clicked');
        });
        divElement.classList.add('clicked');
        document.getElementById('searchCriteriaList').classList.remove('active');
        document.getElementById('detailedViewList').classList.add('active');
        var recordHeader= document.getElementById("detailedViewHeader");
        recordHeader.innerHTML = `${result.displayType} - ${result.identifier}`;
        var recordSection = document.getElementById("recordSection");  

        var actionButton = document.getElementById("actionMenu");
        const actionList = document.getElementById('actionList');

        if (actionList) {
          // clear previous action items in case user clicks different search result entries
          actionList.innerHTML = '';
        }

        let displayType = result.displayType.replace('<em>', '').replace('</em>', '');
        var actions = availableActions[displayType];
        if (actions) {
          actions.forEach(action => {
            const listItem = document.createElement('li');
            listItem.textContent = action.displaytext;
            listItem.addEventListener('click', (event) => {
              var clonedObject = JSON.parse(JSON.stringify(action));
              clonedObject.primarykey = result.primaryKey;
              clonedObject.moniker = result.moniker;
              onZoomToSearchItem("action", JSON.stringify(clonedObject));  
              event.stopPropagation();
            });
            actionList.appendChild(listItem);
          });
        }

        let outputDiv = document.getElementById('detail-output');
        if (outputDiv) {
          outputDiv.innerHTML = '';
        } else {
          outputDiv = document.createElement('div');
          outputDiv.id = "detail-output";
        }
        
        //recordSection.appendChild(outputDiv);

        outputDiv.appendChild(objectToTree(mergedItem, outputDiv, 0));
        recordSection.appendChild(outputDiv);
      }
    }
  });

  return divElement;
}

const availableActions = {
  "Asset": [    
    { moniker: "", applet: "Hansen.AssetManagement.AssetMainBrowserApplet", load: true, primarykey: "", displaytext: "Open in Asset Browser" },
    { moniker: "", applet: "CreateAssetInspection", load: true, primarykey: "", displaytext: "Create Inspection" },
    { moniker: "", applet: "Hansen.WorkManagement.CreateWorkOrderApplet", load: true, primarykey: "", displaytext: "Create Work Order" },
    { moniker: "", applet: "Hansen.CRM.TakeACallApplet", load: true, primarykey: "", displaytext: "Create Service Request" }
  ],
  "Work Order": [
    {moniker:"", applet:"",load:"false",primarykey:"", displaytext : ""}
  ] 
}; 
 
function toggleMenu() {
  let hasActions = false;

  const actionList = document.getElementById('actionList');
  if (actionList) {
    hasActions = actionList.innerHTML != '';
  }
  
  if (actionList && hasActions) {
    actionList.style.display = (actionList.style.display === 'block') ? 'none' : 'block';
  }
}

function hideActionMenu() {
  const actionList = document.getElementById('actionList');
  actionList.style.display = 'none';
}

// Function to convert camelCase to Title Case
function camelToTitleCase(str) {
  return str.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
    return str.toUpperCase();
  });
}

function objectToTree(obj, container, indentLevel) {
    let list = document.createElement('div');
    let indentSize = indentLevel * 10;
    let labelMaxWidth = 147; // set in the css for .field-label
    let valueMaxWidth = 147; // set in the css for .field-value

    for (let key in obj) {
      let isValSet = typeof obj[key] === 'object'; // object types should render
      if (key != 'id' && key != 'moniker' && key != 'displayType') {
        let span = document.createElement('span');
        span.textContent = camelToTitleCase(key);
        span.classList.add('key');
        span.classList.add('field-label');

        if (indentLevel > 0) {
          span.style.maxWidth = ''.concat(labelMaxWidth - indentSize, 'px');
        }

        let entry = document.createElement('div');
        entry.appendChild(span);

        if (typeof obj[key] === 'object') {
            let nestedEntry = objectToTree(obj[key], container, ++indentLevel);
            entry.classList.add('obj-node');
            if (nestedEntry.childNodes.length > 1)
              entry.appendChild(nestedEntry);
        } else {
          let val = obj[key];
          isValSet = hasValue(val);
          if (isValSet) {
            if (key.toLowerCase().includes('date')) {
              val = formatDate(val);
            }
          }


            let valueSpan = document.createElement('span');
            valueSpan.classList.add('value');
            valueSpan.classList.add('field-value');

          valueSpan.innerHTML = `${val}`.replace(/\s/g, '&nbsp;');
          valueSpan.title = `${val}`.replace('<em>', '').replace('</em>', '');

            if (indentLevel > 0) {
              valueSpan.style.maxWidth = ''.concat(valueMaxWidth - indentSize, 'px');
            }
            entry.appendChild(valueSpan);
        }

        let showNode = entry.childNodes.length > 1;
        if (isValSet && showNode) {
          entry.style.paddingLeft = ''.concat(indentSize, 'px');
          list.appendChild(entry);
        }
      }
    }

    return list;
}

// Function to generate HTML for JSON record display
// function generateRecordHTML(jsonObj) {
//   var recordHTML = '';
//   for (var prop in jsonObj) {
//     if (jsonObj.hasOwnProperty(prop) && prop != 'id' && prop != 'moniker' && prop != 'displayType') {
//       var fieldValue = typeof jsonObj[prop] === 'object' ? generateRecordHTML(jsonObj[prop]) : jsonObj[prop];
//       if (hasValue(fieldValue)) {

//         if (prop.toLowerCase().includes('date'))
//           fieldValue = formatDate(fieldValue);

//         var fieldLabel = camelToTitleCase(prop);
//         //recordHTML += '<div><span class="field-label">' + fieldLabel + ':</span> <span class="field-value">' + fieldValue + '</span></div>';
//         //recordHTML += '<div style="display:flex;"><span class="field-label">' + fieldLabel + ':</span> <div class="valueWrapper"><span class="field-value">' + fieldValue + '</span></div></div>';
//         recordHTML += '<div style="display:flex;"><span class="field-label">' + fieldLabel + ':</span> <span class="field-value">' + fieldValue + '</span></div>';
//       }
//     }
//   }
//   return recordHTML;
// }

function formatDate(dateTimeString) {
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  const dateTime = new Date(dateTimeString);
  return dateTime.toLocaleString(undefined, options);
}

function hasValue(str) {
  try {
    return (typeof str === 'string' && str.trim().length > 0);
  } catch (error) {
    console.error('Error occurred checking if value was valid');
  }

  return true;
}

function sortItemsByDisplayType(items) {
  const sortedItems = {};

  items.forEach(item => {
    const displayType = item.source.displayType;
    // Check if the key already exists in the dictionary
    if (!sortedItems[displayType]) {
        // If the key doesn't exist, create a new array with the item
      var record = item.source;
      record.highlight = item.highlight;
      sortedItems[displayType] = [record];
    } else {
      var record = item.source;
      record.highlight = item.highlight;
        // If the key already exists, push the item into the existing array
      sortedItems[displayType].push(record);
    }
  });

  // console.log('printing sortedItems');
  // // Printing the sorted dictionary
  // for (const key in sortedItems) {
  //     if (sortedItems.hasOwnProperty(key)) {
  //         console.log(`Items with displayValue ${key}:`);
  //         sortedItems[key].forEach(item => {
  //             console.log(`- ${item.name} (displayValue: ${item.displayValue})`);
  //         });
  //     }
  // }
  // console.log('done printing sortedItems');

  return sortedItems;
}

function displayUserSearchResults(results, id, contentId) {
  let input = document.getElementById(id);
  let dropdownContent = document.getElementById(contentId);
  let lastSearchResults = results;

  while (dropdownContent.firstChild) {
    dropdownContent.removeChild(dropdownContent.firstChild);
  }

  let username = addCurrentUserToFront(results);
  let seen = false;

  // Display top 10 results
  results.slice(0, 10).forEach(result => {
    if (result.source.primaryContact.fullName) {
      if (seen && username == result.source.identifier) {
        return;
      }

      if (username == result.source.identifier) {
        seen = true;
      }

      var divElement = document.createElement("div");
      // divElement.className = "result-item";
      divElement.innerText = result.source.primaryContact.fullName;

      divElement.addEventListener("click", function() {
        selectOption(divElement.innerText, id, contentId);
        input.setAttribute('identifier', result.source.identifier);
        input.setAttribute('primarycontact', result.source.primaryContact.fullName);
        performSearch();
      });

      dropdownContent.appendChild(divElement);
    }
  });

  showDropdown(id, contentId);
}

function showDropdown(id, contentId) {
  console.log(id);
  console.log(contentId);
  let dropdownContent = document.getElementById(contentId);
  var input = document.getElementById(id);
  dropdownContent.classList.add("show");
}

function hideDropdown(id, contentId) {
  let dropdownContent = document.getElementById(contentId);
  dropdownContent.classList.remove("show");
}

function selectOption(option, id, contentId) {
  document.getElementById(id).value = option;

  hideDropdown(id, contentId);
}


function displaySearchCriteria(data) {
    console.log(data);
    //var aggregations = data.aggregations.departments.buckets;
    //const aggregationsDiv = document.getElementById('searchCriteriaList');
    //aggregationsDiv.innerHTML = '<b>Record Type Aggregations:</b>';

    //// Display record type aggregations
    //aggregations.forEach(agg => {
    //    const div = document.createElement('div');
    //    div.textContent = `${agg.key}: ${agg.doc_count}`;
    //    aggregationsDiv.appendChild(div);
    //});
}

// Mock JSON data containing recent activity
const popularFormsData = [
    { display: "Work Order Lookup", historyKey: "invoices" },
    { display: "Create Service Request", historyKey: "purchases" },
    { display: "Contact and Property Browser", historyKey: "products" },
    { display: "Schedule Resource Calendar", historyKey: "customers" }
];

const recentlyViewedData = [
    { display: "Work Order #1000", historyKey: "invoices" },
    { display: "Account #ACCT10-X-0100", historyKey: "purchases" },
    { display: "Work Order #1002", historyKey: "products" },
    { display: "Service Request #1010", historyKey: "customers" }
];

const savedSearchesData = [
  { display: "Work Orders Mine Assigned", historyKey: "invoices" },
  { display: "Work Orders - Water Mains", historyKey: "purchases" },
  { display: "My Assigned Service Requests", historyKey: "products" },
  { display: "Service Requests on Main St", historyKey: "customers" },
  { display: "Service Requests in Sacramento", historyKey: "customers" },
  { display: "Open Service Requests", historyKey: "customers" },
  { display: "Mr Burns Accounts", historyKey: "customers" },
  { display: "Water Accounts", historyKey: "customers" },
];


function displayHomeSpace() {
    toggleView('searchHomePanel');
    var recentRecordsList = document.getElementById('recentRecordsList');
  var recentFormsList = document.getElementById('recentFormsList');
  var savedSearchesList = document.getElementById('savedSearchesList');
    displayRecentlyViewed(recentRecordsList, recentlyViewedData);
  displayPopularForms(recentFormsList, popularFormsData);
  displaySavedSearches(savedSearchesList, savedSearchesData)
}

// Function to display recent activity
function displayPopularForms(control, jsonData) {
    clearChildDivs(control);
    jsonData.forEach(item => {
        const div = document.createElement('div');
        div.classList.add('result-item');
        div.textContent = item.display;
        div.onclick = () => {
            alert(`displayPopularForms Clicked on ${item.historyKey}`);
        };
        control.appendChild(div);
    });
}

// Function to display recent activity
function displayRecentlyViewed(control, jsonData) {
    clearChildDivs(control);
    jsonData.forEach(item => {
        const div = document.createElement('div');
        div.classList.add('result-item');
        div.textContent = item.display;
        div.onclick = (event) => {
          event.stopPropagation();
          onZoomToSearchItem("Hansen.WorkManagement.WorkOrder","1000");
          //alert(`displayRecentlyViewed Clicked on ${item.historyKey}`);
        };
        control.appendChild(div);
    });
}

function displaySavedSearches(control, jsonData) {
  clearChildDivs(control);
  jsonData.forEach(item => {
    const div = document.createElement('div');
    div.classList.add('result-item');
    div.textContent = item.display;
    //div.onclick = () => {
    //  alert(`displayPopularForms Clicked on ${item.historyKey}`);
    //};
    control.appendChild(div);
  });
}

function onZoomToSearchItem(moniker, appletParams) {
  var home = GetHomeView();
  var apid = getApId(home);
  addEvent(apid, "Hansen.MyHansen.MyHansenApplet", "LaunchAppletFromSearch", "searchBar", "<PARAM val='" + moniker + "' /><PARAM val='" + appletParams + "'/>", undefined, undefined);
  eventAdded(null);
  searchInput.classList.remove('expanded');
  searchResults.classList.remove('active');  
}

function clearChildDivs(parent) {
    if (parent) {
        var children = parent.children;
        for (var i = children.length - 1; i >= 0; i--) {
            var child = children[i];
            if (child.tagName.toLowerCase() === 'div') {
                parent.removeChild(child);
            }
        }
    }
}

function clearUserFilter(id) {
  var elem = document.getElementById(id);
  elem.value = '';
  elem.setAttribute('identifier', '');
  elem.setAttribute('primarycontact', '');

  performSearch();
}

function attachCloseSearchEvents() {
  try {
    // remove when clicking header
    $(window.parent.document).find('#headerContainer').on('click', function(e){
      searchInput.classList.remove('expanded');
      searchResults.classList.remove('active');
    });

    attachEventToIframesById(window.parent, "viewTab", (elem) => {
      $(elem.contentDocument).on('click', function(e){
          searchInput.classList.remove('expanded');
          searchResults.classList.remove('active');
        });
    });
  } catch (error) {
    console.error("An error occurred in attachCloseSearchEvents:", error.message);
  }
}

function attachEventToIframesById(parentWindow, id, callback) {
    $(parentWindow.document).find('#'.concat(id)).each(function() {
      // console.log('Found iframe with id attribute "' + id + '":', this);
      
      callback(this);
    });

    // Recursively search within child iframes
    $(parentWindow.document).find('iframe').each(function() {
        var childWindow = this.contentWindow || this.contentDocument.defaultView;
        if (childWindow) {
            attachEventToIframesById(childWindow, id, callback);
        }
    });
}

function toggleView(viewId) {
    const homeContainer = document.getElementById('searchHomePanel');
    const resultsContainer = document.getElementById('searchResultsPanel');

    if (viewId === 'searchResultsPanel') {
        resultsContainer.classList.add('active');
        homeContainer.classList.remove('active');
    }
    else {
        resultsContainer.classList.remove('active');
        homeContainer.classList.add('active');
    }
}

// Debounce function to limit the frequency of search requests
function debounce(func, delay) {
    let timeoutId;
    return function () {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(func, delay);
    };
}
// initialize
//searchElasticsearch();

//search input code end
